import { render, staticRenderFns } from "./QuestionReports.vue?vue&type=template&id=0d634027&scoped=true&lang=pug&"
import script from "./QuestionReports.vue?vue&type=script&lang=js&"
export * from "./QuestionReports.vue?vue&type=script&lang=js&"
import style0 from "./QuestionReports.vue?vue&type=style&index=0&id=0d634027&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d634027",
  null
  
)

export default component.exports